/* Pip V2.2 motion. No chat / checkout / analytics changes. */
(()=>{'use strict';
const root=document.querySelector('.pip-root.pip-motion-instance[data-pip-motion]');
if(!root||root.dataset.motionReady==='true')return;
root.dataset.motionReady='true';
const button=root.querySelector('.pip-launch'),body=root.querySelector('.pip-motion-avatar'),canvas=root.querySelector('.pip-motion-fur');
if(!button||!body||!canvas)return;
const ctx=canvas.getContext('2d',{alpha:true});
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
let mode='idle',since=0,phase=0,last=0,pointerX=0,pointerY=0,active=false,raf=0,frame=0;
const duration={curious:2.8,hello:1.9,happy:2.5};
let seed=50728;
function rand(){seed=(Math.imul(1664525,seed)+1013904223)>>>0;return seed/4294967296;}
// Delicate motion-lit fur strands over the existing cream mascot; never over the eyes, smile, or headset.
canvas.width=300;canvas.height=300;
ctx.setTransform(.5,0,0,.5,0,0);
const fibers=[];
for(let i=0;i<680;i++){
 let x,y,len,theta;
 if(i<340){theta=.05+Math.PI*.92*rand();const r=.87+.15*rand();x=300+218*Math.cos(theta)*r;y=325+205*Math.sin(theta)*r;len=6+10*rand();}
 else if(i<520){x=155+295*rand();y=128+130*rand();len=5+11*rand();}
 else{x=100+400*rand();y=300+240*rand();len=3+12*rand();}
 const nx=(x-300)/218,ny=(y-325)/210;
 if(nx*nx+ny*ny>1.16)continue;
 if(y>270&&y<435&&x>177&&x<438)continue;
 if((x<165||x>455)&&y<370)continue;
 const ang=Math.atan2(y-318,x-305)+(rand()-.5)*.9;
 fibers.push({x,y,ang,len,p:rand()*Math.PI*2,speed:.63+rand()*1.24,width:.45+rand()*.42,tone:rand()});
}
function drawFur(t,ripple){
 ctx.clearRect(0,0,600,600);ctx.lineCap='round';
 const sway=1.3,pulse=.85+.16*Math.sin(t*2.2);
 for(const h of fibers){
  const gust=Math.sin(t*3.4+h.x*.024+h.y*.016+h.p)*sway;
  const wave=ripple*Math.sin(t*9+h.x*.047-h.y*.015+h.p*.4)*4.4;
  const angle=h.ang+(gust+wave)*.075;
  const len=h.len*(pulse+.15*Math.sin(t*2*h.speed+h.p))*(1+Math.abs(ripple)*.36);
  const dx=Math.cos(angle)*len,dy=Math.sin(angle)*len,alpha=.13+h.tone*.12+Math.abs(ripple)*.07;
  ctx.strokeStyle=h.tone>.66?`rgba(255,255,255,${alpha+.09})`:`rgba(255,224,203,${alpha})`;
  ctx.lineWidth=h.width;ctx.beginPath();ctx.moveTo(h.x,h.y);
  ctx.quadraticCurveTo(h.x+dx*.45+gust*1.5,h.y+dy*.37,h.x+dx+gust,h.y+dy);ctx.stroke();
 }
}
function setMode(next){mode=next;since=phase;}
function tick(now){
 raf=0;
 if(!active||reduced.matches||document.hidden)return;
 if(!last)last=now;
 phase+=Math.min((now-last)/1000,.07);last=now;
 if(mode!=='idle'&&phase-since>(duration[mode]||2.8))setMode('idle');
 const t=phase,elapsed=t-since;
 let x=0,y=-2.7*Math.sin(t*1.7),rot=.8*Math.sin(t*1.3),sx=1+.009*Math.sin(t*2.5),sy=1-.012*Math.sin(t*2.5),ripple=.08+.06*Math.sin(t*2);
 if(mode==='curious'){
  const w=Math.min(1,elapsed*3,Math.max(0,(2.8-elapsed)*2));
  rot+=-7*w;x+=9*w;sy-=.024*w;ripple+=.55*w;
 }
 if(mode==='hello'){
  const p=Math.min(elapsed/1.25,1),spring=Math.exp(-p*2.2)*Math.sin(p*15.5);
  rot+=spring*7;y-=Math.abs(spring)*11;sx+=.047*spring;sy-=.055*spring;ripple+=Math.abs(spring)*1.8;
 }
 if(mode==='happy'){
  const bounce=Math.pow(Math.max(0,1-elapsed/2.5),1.1),jump=Math.max(0,Math.sin(elapsed*10))*bounce;
  y-=jump*21;sx+=.10*Math.sin(elapsed*10)*bounce;sy-=.10*Math.sin(elapsed*10)*bounce;
  rot+=Math.sin(elapsed*7)*6*bounce;ripple+=jump*2.4;
 }
 x+=pointerX*2.5;rot+=pointerX*1.4;sy+=pointerY*.005;
 body.style.transform=`translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,0) rotate(${rot.toFixed(2)}deg) scale(${sx.toFixed(4)},${sy.toFixed(4)})`;
 if((++frame%4)===0 && !button.hidden)drawFur(t,ripple);
 raf=requestAnimationFrame(tick);
}
function stop(){active=false;cancelAnimationFrame(raf);raf=0;last=0;}
function start(){if(active||reduced.matches||document.hidden)return;active=true;last=0;raf=requestAnimationFrame(tick);}
function reset(){stop();body.style.transform='none';ctx.clearRect(0,0,600,600);}
button.addEventListener('pointerenter',()=>{if(!reduced.matches)setMode('curious');});
button.addEventListener('pointerleave',()=>{pointerX=pointerY=0;if(mode==='curious')setMode('idle');});
button.addEventListener('pointermove',e=>{const b=button.getBoundingClientRect();pointerX=Math.max(-1,Math.min(1,((e.clientX-b.left)/b.width-.5)*2));pointerY=Math.max(-1,Math.min(1,((e.clientY-b.top)/b.height-.5)*2));});
button.addEventListener('pointerdown',()=>{if(!reduced.matches)setMode('happy');});
button.addEventListener('click',()=>{if(!reduced.matches)setMode('hello');});
reduced.addEventListener('change',()=>{if(reduced.matches)reset();else start();});
document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else start();});
if(reduced.matches)reset();else start();
})();
